import React from 'react';
import "./Footer.css";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import GitHubIcon from '@mui/icons-material/GitHub';

function Footer() {
    return (
        <div className="gridContainerFooter">


                        <a href="https://www.linkedin.com/in/jazzysince1992/"> <li> <h3>LinkedIn <LinkedInIcon/></h3> </li> </a>
                        <a href="https://github.com/Jazzysince1992"> <li> <h3>Github <GitHubIcon/></h3> </li> </a>
                        <a href="https://www.facebook.com/saurabh.jaiswal.92560/"><li> <h3> Facebook<FacebookIcon/></h3></li></a>


        </div>
    )
}

export default Footer

